import React, { useRef, useState } from "react";
import styled from "styled-components";
import { EditorState, convertToRaw } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import draftToHtml from "draftjs-to-html";
import "../../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { useDispatch, useSelector } from "react-redux";
import { selectLoading } from "../Products/productsAdminSlice";
import { sendEmailToAll } from "./emailSenderSlice";
import { RiSendPlaneFill } from "react-icons/ri";
import Button from "@material-ui/core/Button";
import { TextField } from "@material-ui/core";
import {
  ProgressBar,
  BorderLinearProgress,
} from "components/Admin/InputFields/utils";

interface EmailSenderProps {}

const EmailSender: React.FC<EmailSenderProps> = ({}) => {
  const dispatch = useDispatch();
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const [htmlToString, setHtmlToString] = useState("");
  const [text, setText] = useState("");
  const [progress, setProgress] = useState(0);

  const handleChange = (event: any) => {
    setText(event.target.value);
  };

  const onEditorStateChange = (editorState: any) => {
    setEditorState(editorState);
    setHtmlToString(draftToHtml(convertToRaw(editorState.getCurrentContent())));
  };

  const sent = () => {
    const subject = text;
    const content = { subject, htmlToString };
    dispatch(
      sendEmailToAll(content, (event) => {
        setProgress(Math.round((100 * event.loaded) / event.total));
      })
    );
  };

  return (
    <EmailSenderContainer>
      <ButtonsContainer>
        <Button
          disabled={progress !== 0 && progress !== 100}
          variant="contained"
          color="primary"
          startIcon={<RiSendPlaneFill size="1.5rem" />}
          onClick={sent}
        >
          Изпрати
        </Button>
      </ButtonsContainer>
      <ProgressBar>
        <BorderLinearProgress variant="determinate" value={progress} />
      </ProgressBar>
      <SubjectField label="Заглавие" variant="filled" onChange={handleChange} />
      <Editor
        editorState={editorState}
        wrapperClassName="demo-wrapper"
        editorClassName="demo-editor"
        onEditorStateChange={onEditorStateChange}
      />
      {/* <TextArea
        disabled
        value={draftToHtml(convertToRaw(editorState.getCurrentContent()))}
      /> */}
    </EmailSenderContainer>
  );
};

const ButtonsContainer = styled.div`
  margin: 10px 0;
`;

const EmailSenderContainer = styled.div`
  .demo-editor {
    border-radius: 5px;
    width: 100%;
    border-radius: 2px;
    /* resize: none; */
    height: 500px;
    background-color: white;
    padding: 5px;
    margin-bottom: 10px;
  }
`;

const SubjectField = styled(TextField)`
  width: 100%;
  margin: 10px 0;
`;
export default EmailSender;
